var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToken = function SvgToken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14H3v1h1v-1ZM3 13H2v1h1v-1ZM2 12H1v1h1v-1ZM1 3H0v9h1V3ZM10 8H9v2h1V8ZM8 5H7v2h1V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2h-1V1h-1V0H5v1H4v1H3v1H2v9h1v1h1v1h1v1h8v-1h1v-1h1v-1h1V3h-1V2ZM5 9h1v1h2V8H6V7H5V5h1V4h2V3h1v1h2v1h1v1h-1V5H9v2h2v1h1v2h-1v1H9v1H8v-1H6v-1H5V9Zm10-5v7h-1v1h-1v1h-1v1h-1v-1h1v-1h1v-1h1V4h-1V3h-1V2H6v1H5v1H4v6H3V4h1V3h1V2h1V1h6v1h1v1h1v1h1ZM2 2H1v1h1V2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1H2v1h1V1ZM4 0H3v1h1V0Z",
    fill: "currentColor"
  })));
};
export default SvgToken;